export interface DocumentRevision {
  message: string;
  revision: number;
  status: DocumentRevisionStatus;
  editorBlockContentVersions: EditorBlockContentVersion[];
}

export interface DocumentRecipientRevision {
  createdAt: number;
  message: string;
  revision: number;
  status: DocumentRevisionStatus;
  viewedByRecipient: boolean;
  editorBlockContentVersions?: EditorBlockContentVersion[];
}

export enum DocumentRevisionStatus {
  Started = 'Started',
  Sealed = 'Sealed',
  Failed = 'Failed',
  NonSignable = 'NonSignable',
}

export interface EditorBlockContentVersion {
  blockId: string;
  contentId: string;
  versions: EditorContentVersion[];
}

export interface EditorContentVersion {
  versionId: string;
  lastModified: string;
  isLatest: boolean;
  isPublished: boolean;
}
